import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const ArticleLink = styled(Link)`
  display: inline-block;
  position: relative;
  ${({ visible }) => (visible ? 'width: 100%;' : null)};
  max-width: 100%;
  padding: 12px 30px 12px 3px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.font};

  > span {
    display: block;
    position: relative;
    transition: transform 0.2s ease;
  }

  svg {
    position: absolute;
    top: 3px;
  }

  svg:last-child {
    left: auto;
    right: -24px;
    transition: transform 0.15s ease;
  }

  /* stylelint-disable */
  &:hover {
    color: ${({ theme }) => theme.mainColor};

    svg:last-child {
      transform: translateX(3px);
    }
  }
  /* stylelint-enable */

  ${minMediaQueries.tablet`
    ${({ visible }) => (!visible ? 'display: none;' : null)};
  `};
`;
